(ns frontend.test-ribbon.sub
  (:require
   [re-frame.core :as rf]
   [reagent.ratom :as ratom]
   [ui.state.session.sub :as session-sub]
   [common.entity :as entity]
   [common.localization :as loc]
   [frontend.test-ribbon.model :as model]
   [frontend.state.current-session :as session]))

(rf/reg-sub
 ::state
 (fn [db]
   (get-in db model/root-path)))

(rf/reg-sub
 ::current-ribbon-id
 :<- [::state]
 (fn [state]
   (get-in state model/ribbon-id-path)))

(rf/reg-sub
 ::current-tab-id
 :<- [::state]
 (fn [state]
   (get-in state model/tab-id-path)))

(rf/reg-sub
 ::tabs-by-ribbon-id
 :<- [::session-sub/entities-for-type :entity.type/tab]
 (fn [tabs]
   (->> tabs
        (group-by :tab/ribbon))))

(rf/reg-sub
 ::current-ribbon
 :<- [::current-ribbon-id]
 :<- [::session-sub/entities]
 (fn [[ribbon-id entities]]
   (get entities ribbon-id)))

(rf/reg-sub
 ::current-ribbon-name
 :<- [::current-ribbon]
 (fn [current-ribbon]
   (:ribbon/name current-ribbon)))

(rf/reg-sub
 ::all-ribbons
 :<- [::session-sub/entity-types]
 (fn [entities-by-type]
   (let [ribbons (get entities-by-type :entity.type/ribbon)]
     ribbons)))

(rf/reg-sub
 ::all-ribbons-count
 :<- [::all-ribbons]
 (fn [ribbons]
   (count ribbons)))

(rf/reg-sub
 ::current-tab
 :<- [::current-tab-id]
 :<- [::session-sub/entities]
 (fn [[tab-id entities]]
   (get entities tab-id)))

(rf/reg-sub
 ::current-ribbon-default-tabs
 :<- [::current-ribbon]
 :<- [::session-sub/entities]
 (fn [[ribbon entitities-by-id]]
   (->> ribbon
        :ribbon/default-tabs
        (mapv (fn [tab-id]
                (get entitities-by-id tab-id)))
        (sort-by :common/ord)
        (vec))))

(rf/reg-sub
 ::current-ribbon-default-tab-count
 :<- [::current-ribbon-default-tabs]
 (fn [default-tabs]
   (count default-tabs)))

(rf/reg-sub
 ::current-ribbon-temp-tabs
 :<- [::current-ribbon-id]
 :<- [::tabs-by-ribbon-id]
 (fn [[current-ribbon-id tabs-by-ribbon-id]]
   (->> current-ribbon-id
        (get tabs-by-ribbon-id)
        (sort-by :common/ord)
        (vec))))

(rf/reg-sub
 ::current-view
 :<- [::current-tab]
 :<- [::session-sub/entities]
 (fn [[tab entities]]
   (let [view-id (:tab/current-view tab)
         view (get entities view-id)]
     view)))

(rf/reg-sub
 ::current-view-type
 :<- [::current-view]
 (fn [current-view]
   (:view/type current-view)))

(rf/reg-sub
 ::current-ribbon-tab-ids
 :<- [::current-ribbon]
 :<- [::tabs-by-ribbon-id]
 :<- [::session-sub/entities]
 (fn [[ribbon tabs-by-ribbon-id entities]]
   (let [ribbon-id (:db/id ribbon)
         default-tab-ids (:ribbon/default-tabs ribbon)
         default-tabs (->> default-tab-ids
                           (mapv (fn [id]
                                   (get entities id)))
                           (sort-by :common/ord)
                           (vec))
         temp-tabs (get tabs-by-ribbon-id ribbon-id)
         temp-tabs (->> temp-tabs
                        (sort-by :common/ord)
                        (vec))
         tabs (vec (concat default-tabs temp-tabs))
         tab-ids (mapv :db/id tabs)]
     tab-ids)))

(rf/reg-sub
 ::default-tab?
 :<- [::current-ribbon]
 (fn [current-ribbon [_ tab-id]]
   (-> current-ribbon
       :ribbon/default-tabs
       set
       (some [tab-id]))))

(rf/reg-sub-raw
 ::tab-state
 (fn [_db-atom [_ tab-id]]
   (let []
     (ratom/make-reaction
      (fn []
        (let [current-tab-id @(rf/subscribe [::current-tab-id])
              entities @(rf/subscribe [::session-sub/entities])

              default-tab? @(rf/subscribe [::default-tab? tab-id])

              tab (get entities tab-id)
              tab-view-id (:tab/current-view tab)
              viewed-entity-id (:tab/viewed-entity tab)
              mandatory? (:tab/mandatory? tab)
              focused? (= tab-id current-tab-id)

              tab-view (get entities tab-view-id)
              tab-view-type (:view/type tab-view)
              nev-view? (= tab-view-type :view.type/single-entity)

              ;; FIXME: fix once grid views implemented
              grid-view? (not nev-view?)

              title (cond
                      nev-view?
                      (->> viewed-entity-id
                           session/get-entity
                           entity/display-string)
                      ;; FIXME: fix once grid views implemented
                      :else (loc/tr :companies-grid))

              kicker (cond
                       nev-view? (-> tab-view
                                     :view/entity-type
                                     loc/tr)
                       grid-view? (loc/tr :table)
                       :else nil)]

          {:id (:db/id tab)
           :title title
           :kicker kicker
           :focused? focused?
           :mandatory? mandatory?
           :default-tab? default-tab?}))
      {:on-dispose (fn [arg]
                     #_(swap! tab-cache dissoc tab-id))}))))

(rf/reg-sub
 ::move-tab-to-another-ribbon-options
 :<- [::current-ribbon-id]
 :<- [::session-sub/entities-for-type :entity.type/ribbon]
 (fn [[current-ribbon-id ribbons]]
   (->> ribbons
        (filterv (fn [{:keys [db/id]}]
                   (not= id current-ribbon-id)))
        (mapv (fn [ribbon]
                {:value (:db/id ribbon)
                 :label (:ribbon/name ribbon)})))))
